export default [
  {
    Category: "CNC",
    Brand: "TAKUMI",
    "Machine Model": "H16",
    "Machine Quantity": 20,
  },
  {
    Category: "CNC",
    Brand: "TAKUMI",
    "Machine Model": "H12",
    "Machine Quantity": 5,
  },
  {
    Category: "CNC",
    Brand: "MAKINO",
    "Machine Model": "V33i",
    "Machine Quantity": 1,
  },
  {
    Category: "CNC",
    Brand: "MAKINO",
    "Machine Model": "V56",
    "Machine Quantity": 1,
  },
  {
    Category: "CNC",
    Brand: "MAKINO",
    "Machine Model": "V99",
    "Machine Quantity": 1,
  },
  {
    Category: "CNC",
    Brand: "MAKINO",
    "Machine Model": "SNC64",
    "Machine Quantity": 1,
  },
  {
    Category: "CNC",
    Brand: "AWEA",
    "Machine Model": "LP4025YZF",
    "Machine Quantity": 2,
  },
  {
    Category: "CNC",
    Brand: "KURAKI",
    "Machine Model": "KBT-13EB-A",
    "Machine Quantity": 2,
  },
  {
    Category: "CNC",
    Brand: "TOSHIBA",
    "Machine Model": "TOSHIBA2130",
    "Machine Quantity": 2,
  },
  {
    Category: "CNC",
    Brand: "RAMBAUDI",
    "Machine Model": "RC270",
    "Machine Quantity": 3,
  },
  {
    Category: "CNC",
    Brand: " HAIMER",
    "Machine Model": "C40U",
    "Machine Quantity": 3,
  },
  {
    Category: "CNC",
    Brand: "QUICK JET",
    "Machine Model": "AV3021X",
    "Machine Quantity": 1,
  },
  {
    Category: "CNC",
    Brand: "SENMADE",
    "Machine Model": "HG600",
    "Machine Quantity": 2,
  },
  {
    Category: "EDM",
    Brand: "SODIC",
    "Machine Model": "AG100L",
    "Machine Quantity": 2,
  },
  {
    Category: "EDM",
    Brand: "SODIC",
    "Machine Model": "AQ15L",
    "Machine Quantity": 2,
  },
  {
    Category: "EDM",
    Brand: "SODIC",
    "Machine Model": "AM55L",
    "Machine Quantity": 1,
  },
  {
    Category: "EDM",
    Brand: "SODIC",
    "Machine Model": "AM65 ",
    "Machine Quantity": 1,
  },
  {
    Category: "EDM",
    Brand: "SODIC",
    "Machine Model": "AQ35L ",
    "Machine Quantity": 3,
  },
  {
    Category: "EDM",
    Brand: "SODIC",
    "Machine Model": "AG60",
    "Machine Quantity": 1,
  },
  {
    Category: "EDM",
    Brand: "SODIC",
    "Machine Model": "AQ75L ",
    "Machine Quantity": 1,
  },
  {
    Category: "EDM",
    Brand: "SODIC",
    "Machine Model": "AQ55L",
    "Machine Quantity": 3,
  },
  {
    Category: "EDM",
    Brand: "SODIC",
    "Machine Model": "A15",
    "Machine Quantity": 1,
  },
  {
    Category: "EDM",
    Brand: "RX",
    "Machine Model": "HG50",
    "Machine Quantity": 1,
  },
  {
    Category: "EDM",
    Brand: "MAKINO",
    "Machine Model": "EDNC106",
    "Machine Quantity": 1,
  },
  {
    Category: "EDM",
    Brand: "ONA",
    "Machine Model": "QX6",
    "Machine Quantity": 4,
  },
  {
    Category: "EDM",
    Brand: "DAEHAN",
    "Machine Model": "TURBO3500CNC",
    "Machine Quantity": 2,
  },
  {
    Category: "EDM",
    Brand: "RX",
    "Machine Model": "HG100",
    "Machine Quantity": 2,
  },
  {
    Category: "EDM",
    Brand: "RX",
    "Machine Model": "HG200",
    "Machine Quantity": 6,
  },
  {
    Category: "WEDM",
    Brand: "SODIC",
    "Machine Model": "AQ900L",
    "Machine Quantity": 2,
  },
  {
    Category: "WEDM",
    Brand: "SODIC",
    "Machine Model": "AQ750L",
    "Machine Quantity": 2,
  },
  {
    Category: "WEDM",
    Brand: "SODIC",
    "Machine Model": "AQ537L",
    "Machine Quantity": 3,
  },
  {
    Category: "WEDM",
    Brand: "MAKINO",
    "Machine Model": "U6",
    "Machine Quantity": 8,
  },
  {
    Category: "Fitting Machine",
    Brand: "YANGZHOU FORGE",
    "Machine Model": "400T",
    "Machine Quantity": 1,
  },
  {
    Category: "Fitting Machine",
    Brand: "YANGZHOU FORGE",
    "Machine Model": "160T",
    "Machine Quantity": 1,
  },
  {
    Category: "Fitting Machine",
    Brand: "YANGLI",
    "Machine Model": "250T",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "HAITIAN",
    "Machine Model": "HTF450",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "HAITIAN",
    "Machine Model": "3300HTF",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "HAITIAN",
    "Machine Model": "1600HTF",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "HAITIAN",
    "Machine Model": "800HTF",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "DONGHUA",
    "Machine Model": "HTF600",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "DONGHUA",
    "Machine Model": "380HTF",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "YT",
    "Machine Model": "250T",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "JSW",
    "Machine Model": "110T",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "CHEN HSONG",
    "Machine Model": "1250T",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "Engel",
    "Machine Model": "1700T",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "KRAUSSMAFFEI",
    "Machine Model": "3200T",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "ZHAFIR",
    "Machine Model": "300T",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "HAITIAN",
    "Machine Model": "900T",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "HAITIAN",
    "Machine Model": "900T",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "HAITIAN",
    "Machine Model": "2300T",
    "Machine Quantity": 1,
  },
  {
    Category: "Injection Machine",
    Brand: "HAITIAN",
    "Machine Model": "1300T",
    "Machine Quantity": 1,
  },
];
